module.exports = "/static/assets/e4c882dd37a1d25a582067265eded81c.png";